import { Box, Typography } from '@mui/material'

export default function ChangeMakerMissionSection({ title, text }) {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4, lg: 6 },
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          flexShrink: 0,
          maxWidth: { md: 280, lg: 308 },
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: 20, sm: 24, md: 30, lg: 30 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          width: { xs: '100%', md: 700, lg: 1000 },
          maxWidth: '100%',
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}
